import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const CultureRoute = lazyWithRetries(() => import('./'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.culture(),
    element: (
      <StandardPageLayout elementId="cultureRoute" maxWidth={900} title={<T _str="Culture" />}>
        <Suspense fallback={<RouteLoading />}>
          <CultureRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
